// src/assertion.ts
function isKeyboardClick(e) {
  return e.detail === 0 || e.clientX === 0 && e.clientY === 0;
}
function isPrintableKey(e) {
  return e.key.length === 1 && !e.ctrlKey && !e.metaKey;
}
function isVirtualPointerEvent(e) {
  return e.width === 0 && e.height === 0 || e.width === 1 && e.height === 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "mouse";
}
function isVirtualClick(e) {
  if (e.mozInputSource === 0 && e.isTrusted)
    return true;
  return e.detail === 0 && !e.pointerType;
}
var isLeftClick = (e) => e.button === 0;
var isContextMenuEvent = (e) => {
  return e.button === 2 || isCtrlKey(e) && e.button === 0;
};
var isModifiedEvent = (e) => e.ctrlKey || e.altKey || e.metaKey;
var isMac = () => /Mac|iPod|iPhone|iPad/.test(window.navigator.platform);
var isCtrlKey = (e) => isMac() ? e.metaKey && !e.ctrlKey : e.ctrlKey && !e.metaKey;

export {
  isKeyboardClick,
  isPrintableKey,
  isVirtualPointerEvent,
  isVirtualClick,
  isLeftClick,
  isContextMenuEvent,
  isModifiedEvent,
  isCtrlKey
};
